import { features } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-3xl font-heading text-foreground-900 mb-2">
            平台特色
          </h2>
          <p className="text-sm text-foreground-600">为什么选择每日大赛入口在线观看赛事视频</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {features.map((feature, index) => (
            <div
              key={feature.id}
              className="rounded-xl p-5 md:p-6 text-center group hover:bg-background-100 transition-colors"
            >
              <span
                className={`w-14 h-14 mx-auto flex items-center justify-center rounded-2xl mb-4 transition-colors ${
                  index === 0 ? 'bg-primary-100 text-primary-600' :
                  index === 1 ? 'bg-accent-100 text-accent-600' :
                  index === 2 ? 'bg-secondary-100 text-secondary-600' :
                  index === 3 ? 'bg-primary-100 text-primary-600' :
                  'bg-accent-100 text-accent-600'
                }`}
              >
                <i className={`${feature.icon} text-2xl`}></i>
              </span>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}